export default __webpack_public_path__ + "static/media/search.44677d0e.svg";